<p-treeTable
    #tree
    [lazy]="true"
    (onLazyLoad)="lazyloadAccounts($event)"
    (onNodeExpand)="onAccountExpand($event)"
    [totalRecords]="totalAccountsNumber"
    [loading]="loadingAccounts"
    [value]="accounts"
    [columns]="cols"
    dataKey="id"
    [contextMenu]="cm"
    contextMenuSelectionMode="joint"
    [scrollable]="true" scrollHeight="300px"
    [selectionMode]="this.selectionMode"
    [(selection)]="this.selected"
    (onNodeSelect)="onNode()"
    (onNodeUnselect)="onNode()"
>
    <ng-template pTemplate="caption">
        <input type="text" pInputText placeholder="Search accounts..." (input)="tree.filterGlobal($event.target.value, 'contains')" class="search-accounts-input">
    </ng-template>
    <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
            <col *ngFor="let col of tableColumns" [style.width]="col.width">
        </colgroup>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of cols">
                {{ col.header }}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr [ttContextMenuRow]="rowNode" [ttSelectableRow]="rowNode">
            <td *ngFor="let col of cols; let i = index">
                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0">
                </p-treeTableToggler>
                {{rowData[col.field]}}
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="cols.length">No data found.</td>
        </tr>
    </ng-template>
</p-treeTable>
<p-contextMenu #cm [model]="items" appendTo="body"></p-contextMenu>
